// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6cbfe893","239":"c361e6ae","453":"fb30790f","732":"130a5303"}[chunkId] + ".chunk.js";
};